<app-bread-crumb [items]="[{text:'stock'}]" [sectionTitle]="'Lista de Produtos do Stock'"></app-bread-crumb>

<section class="content">

    <div class="row">
        <div class="col-md-12">

            <!-- inicio do box -->
            <ng-box [boxIcon]="'fa fa-shopping-cart'" [boxTitle]="'Stock'">

                <!-- cabesalho do box -->
                <ng-container class="ng-box-header">

                    <ng-button *ngIf="isAdminOrManager()" (click)="create()"
                        [button]="{name:'nova stock', faIconClass:'fa fa-plus',color:'danger'}">
                    </ng-button>

                </ng-container>

                <!-- box-content -->
                <ng-container class="ng-box-content">

                    <!-- inicio da tabela -->
                    <ng-table [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">

                        <tr *ngFor="let stock of objects" ngChangeColorOnHover>

                            <td>
                                <strong style="font-size:medium;color:#f35309">{{stock.productName }} - {{stock.colorDescription}} - {{stock.size}}</strong> <br>
                                <small *ngIf="!isAdminOrUserKhuzela()">{{stock.productDescription}}</small>
                                <small *ngIf="isAdminOrUserKhuzela()">{{stock.clubName}}</small>
                            </td>

                            <td>{{stock.product_code}}</td>
                            <td>{{stock.price }}</td>
                            <td>{{stock.quant_total }}</td>
                            <td>
                                <span *ngIf="stock.statusName==='Disponivel'"
                                    class="label label-success">{{stock.statusName}}</span>
                                <span *ngIf="stock.statusName==='Indisponivel'"
                                    class="label label-danger">{{stock.statusName}}</span>
                                <span *ngIf="stock.statusName==='Esgotado'"
                                    class="label label-warning">{{stock.statusName}}</span>
                            </td>

                            <!-- controles -->
                            <ng-actions-table-bar>

                                <ng-button title="Editar" (click)="edit(stock)"
                                    [button]="{faIconClass:'fa fa-edit',color:'danger'}">
                                </ng-button>

                                <ng-button title="Detalhe" (click)="detail(stock)"
                                    [button]="{faIconClass:'fa fa-eye',color:'danger'}">
                                </ng-button>

                                <ng-button *ngIf="isAdminOrManager()" title="Excluir" (click)="delete(stock)"
                                    [button]="{faIconClass:'fa fa-close',color:'danger'}"></ng-button>

                            </ng-actions-table-bar>

                        </tr>

                    </ng-table>
                    <!-- fim da tabela -->

                    <box-loading class="overlay" *ngIf="isSpinnerLoading"></box-loading>

                </ng-container>
                <!-- fim do conteudo do box -->
            </ng-box>
            <!-- fim do box -->
        </div>
    </div>
</section>